import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";
import Service from "../../services/service";
import useAuthStore from "stores/useAuthStore";
import Logo from "../../assets/Images/logo.png";

const OtpPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [otp, setOtp] = useState("");
  const [email] = useState(location.state?.email);
  const setAuthToken = useAuthStore((state) => state.setAuthToken);

  useEffect(() => {
    if (!email) {
      showErrorToast("Email is missing. Please go back and try again.");
      navigate("/login");
    }
  }, [email, navigate]);

  const handleVerifyOtp = async () => {
    if (!otp) {
      showErrorToast("OTP is required");
      return;
    }

    try {
      const payload = { email, otp };
      const response = await Service.verifyOtp(payload);

      if (response && response.data ) {

        // Save the token in Zustand store
        setAuthToken(response.data.data.token);

        navigate("/");
        showSuccessToast("OTP Verifed Successfully !");
      }
    } catch (error) {
      showErrorToast("Failed to verify OTP. Please try again.");
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-card">
        {/* Logo Section */}
        <div className="signup-logo-section">
          <img src={Logo} alt="Logo" className="signup-logo " />
        </div>

        {/* Sign-In Section */}
        <div >
          <h1 className="signup-header">Authentication Required</h1>
          <p className="Signup-otp-subheading">
            We’ve sent a One Time Password (OTP) to the email{" "}
            <strong>{email}</strong>. Please enter it to complete verification.
          </p>

          {/* OTP Input */}
          <div className="input-section">
            <h2 className="signup-input-container">Enter OTP</h2>
            <label className="email-input">
              <input
                type="text"
                name="otp"
                placeholder="Enter your OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                className="signup-input"
              />
            </label>
          </div>

          {/* Continue Button */}
          <button className="signup-continue-button" onClick={handleVerifyOtp}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtpPage;
